import { currency } from '../../../helpers/currency_fomat'
import { useCart } from '../../../hooks/useCart'
import * as Styled from '../styles'

export const ConfirmOrder = () => {
  const { cart, confirmOrder } = useCart()

  const totalAmount = cart.reduce((acc, item) => acc + item.subtotal, 0)
  return (
    <Styled.Container>
      <button type='button' onClick={confirmOrder}>
        Finalizar Pedido
      </button>
      <span>
        Total: <strong> {currency(totalAmount)}</strong>
      </span>
    </Styled.Container>
  )
}
